import ReactDOM from 'react-dom';
import { createBrowserHistory, History } from 'history';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import {
    ConnectedRouter,
    connectRouter,
    routerMiddleware
} from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Reducers from './reducers/Reducers';
import STORE from './store';
import Login from './Login';
import AuthorizedRoute from './AuthorizedRoute';
import {
    ACCOUNT,
    CONFIGURATION,
    EMPLOYEES,
    PRODUCTS,
    PRODUCT_CATEGORIES,
    STORE_CLOSING,
    TABLES
} from './Constants';
import Categories from './Categories';
import Notifier from './Notifier';
import Tables from './Tables';
import StoreConfiguration from './StoreConfiguration';
import Account from './Account';
import Products from './Products';
import Employees from './Employees';
import Error from './Error';
import StoreClosing from './StoreClosing';

import './i18n';
import './styles/main.less';

const browserHistory = createBrowserHistory();
const middlewares: any[] = [thunk, routerMiddleware(browserHistory)];

if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({
        collapsed: true,
        titleFormatter: action => `${action.type}`
    });
    middlewares.push(logger);
}

const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        app: Reducers
    });

const configureStore = (initialState = STORE) =>
    createStore(
        createRootReducer(browserHistory),
        initialState,
        applyMiddleware(...middlewares)
    );

ReactDOM.render(
    <Provider store={configureStore()}>
        <ConnectedRouter history={browserHistory}>
            <SnackbarProvider
                maxSnack={4}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                hideIconVariant>
                <Notifier />
                <Switch>
                    <Route exact path='/' component={Login} />
                    <Route exact path='/error' component={Error} />
                    <Switch>
                        <AuthorizedRoute
                            exact
                            path={PRODUCT_CATEGORIES}
                            component={Categories}
                        />
                        <AuthorizedRoute exact path={PRODUCTS} component={Products} />
                        <AuthorizedRoute
                            exact
                            path={CONFIGURATION}
                            component={StoreConfiguration}
                        />
                        <AuthorizedRoute exact path={EMPLOYEES} component={Employees} />
                        <AuthorizedRoute exact path={TABLES} component={Tables} />
                        <AuthorizedRoute exact path={ACCOUNT} component={Account} />
                        <AuthorizedRoute
                            exact
                            path={STORE_CLOSING}
                            component={StoreClosing}
                        />
                    </Switch>
                </Switch>
            </SnackbarProvider>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);
